"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cloudflare = void 0;
const msal_browser_1 = require("@azure/msal-browser");
const envDetector_1 = require("../../../build-babel/utils/envDetector");
const MSAL_CACHE_CONFIG = {
  cacheLocation: msal_browser_1.BrowserCacheLocation.LocalStorage,
  storeAuthStateInCookie: false
};
const BROWSER_SYSTEM_OPTIONS = {
  loggerOptions: {
    logLevel: msal_browser_1.LogLevel.Verbose,
    loggerCallback: (level, message) => {
      switch (level) {
        case msal_browser_1.LogLevel.Error:
          console.error(message);
          return;
        case msal_browser_1.LogLevel.Info:
          console.info(message);
          return;
        case msal_browser_1.LogLevel.Verbose:
          console.debug(message);
          return;
        case msal_browser_1.LogLevel.Warning:
          console.warn(message);
          return;
      }
    },
    piiLoggingEnabled: false
  }
};
const MSAL_CONFIG = {
  localhost: {
    auth: {
      clientId: 'f045eac5-d62c-464c-8a28-a0c4e4cb5ce9',
      authority: 'https://identity-dev.hlag.cloud/hlagwebdev.onmicrosoft.com/B2C_1A_SIGNUP_SIGNIN',
      knownAuthorities: ['identity-dev.hlag.cloud'],
      redirectUri: 'https://wwwdeve.hapag-lloyd.com/solutions/auth/'
    },
    system: BROWSER_SYSTEM_OPTIONS,
    cache: MSAL_CACHE_CONFIG,
    homepageUri: 'https://wwwdeve.hapag-lloyd.com/en/home.html',
    aem: {
      logoutAEMUri: 'https://wwwtest.hapag-lloyd.com/en/online-business/logout-only.html'
    },
    globalFrontendScripts: 'https://wwwdeve.hapag-lloyd.com/solutions/global-frontend-scripts',
    authorities: {
      editProfile: 'https://identity-dev.hlag.cloud/hlagwebdev.onmicrosoft.com/B2C_1A_PROFILEEDIT',
      changePassword: 'https://identity-dev.hlag.cloud/hlagwebdev.onmicrosoft.com/B2C_1A_CHANGEPASSWORD'
    }
  },
  deve: {
    auth: {
      clientId: 'f045eac5-d62c-464c-8a28-a0c4e4cb5ce9',
      authority: 'https://identity-dev.hlag.cloud/hlagwebdev.onmicrosoft.com/B2C_1A_SIGNUP_SIGNIN',
      knownAuthorities: ['identity-dev.hlag.cloud'],
      redirectUri: 'https://wwwdeve.hapag-lloyd.com/solutions/auth/'
    },
    cache: MSAL_CACHE_CONFIG,
    system: BROWSER_SYSTEM_OPTIONS,
    homepageUri: 'https://wwwdeve.hapag-lloyd.com/en/online-business.html',
    aem: {
      logoutAEMUri: 'https://wwwdeve.hapag-lloyd.com/en/online-business/logout-only.html'
    },
    globalFrontendScripts: 'https://wwwdeve.hapag-lloyd.com/solutions/global-frontend-scripts',
    authorities: {
      editProfile: 'https://identity-dev.hlag.cloud/hlagwebdev.onmicrosoft.com/B2C_1A_PROFILEEDIT',
      changePassword: 'https://identity-dev.hlag.cloud/hlagwebdev.onmicrosoft.com/B2C_1A_CHANGEPASSWORD'
    }
  },
  'deve-china': {
    auth: {
      clientId: 'f045eac5-d62c-464c-8a28-a0c4e4cb5ce9',
      authority: 'https://identity-dev-cn.hlag.cloud/hlagwebdev.onmicrosoft.com/B2C_1A_SIGNUP_SIGNIN',
      knownAuthorities: ['identity-dev-cn.hlag.cloud'],
      redirectUri: 'https://wwwdeve.hapag-lloyd.cn/solutions/auth/'
    },
    cache: MSAL_CACHE_CONFIG,
    system: BROWSER_SYSTEM_OPTIONS,
    homepageUri: 'https://wwwdeve.hapag-lloyd.cn/en/online-business.html',
    aem: {
      logoutAEMUri: 'https://wwwdeve.hapag-lloyd.cn/en/online-business/logout-only.html'
    },
    globalFrontendScripts: 'https://wwwdeve.hapag-lloyd.cn/solutions/global-frontend-scripts',
    authorities: {
      editProfile: 'https://identity-dev-cn.hlag.cloud/hlagwebdev.onmicrosoft.com/B2C_1A_PROFILEEDIT',
      changePassword: 'https://identity-dev-cn.hlag.cloud/hlagwebdev.onmicrosoft.com/B2C_1A_CHANGEPASSWORD'
    }
  },
  qa: {
    auth: {
      clientId: 'e43eb5c2-ce80-43f3-ba6a-6077b6accdc2',
      authority: 'https://identity-qa.hlag.cloud/hlagwebqa.onmicrosoft.com/B2C_1A_SIGNUP_SIGNIN',
      knownAuthorities: ['identity-qa.hlag.cloud'],
      redirectUri: 'https://wwwtest.hapag-lloyd.com/solutions/auth/'
    },
    cache: MSAL_CACHE_CONFIG,
    system: BROWSER_SYSTEM_OPTIONS,
    homepageUri: 'https://wwwtest.hapag-lloyd.com/en/home.html',
    aem: {
      logoutAEMUri: 'https://wwwtest.hapag-lloyd.com/en/online-business/logout-only.html'
    },
    globalFrontendScripts: 'https://wwwtest.hapag-lloyd.com/solutions/global-frontend-scripts',
    authorities: {
      editProfile: 'https://identity-qa.hlag.cloud/hlagwebqa.onmicrosoft.com/B2C_1A_PROFILEEDIT',
      changePassword: 'https://identity-qa.hlag.cloud/hlagwebqa.onmicrosoft.com/B2C_1A_CHANGEPASSWORD'
    }
  },
  'qa-china': {
    auth: {
      clientId: 'e43eb5c2-ce80-43f3-ba6a-6077b6accdc2',
      authority: 'https://identity-qa-cn.hlag.cloud/hlagwebqa.onmicrosoft.com/B2C_1A_SIGNUP_SIGNIN',
      knownAuthorities: ['identity-qa-cn.hlag.cloud'],
      redirectUri: 'https://wwwtest.hapag-lloyd.cn/solutions/auth/'
    },
    cache: MSAL_CACHE_CONFIG,
    system: BROWSER_SYSTEM_OPTIONS,
    homepageUri: 'https://wwwtest.hapag-lloyd.cn/en/home.html',
    aem: {
      logoutAEMUri: 'https://wwwtest.hapag-lloyd.cn/en/online-business/logout-only.html'
    },
    globalFrontendScripts: 'https://wwwtest.hapag-lloyd.cn/solutions/global-frontend-scripts',
    authorities: {
      editProfile: 'https://identity-qa-cn.hlag.cloud/hlagwebqa.onmicrosoft.com/B2C_1A_PROFILEEDIT',
      changePassword: 'https://identity-qa-cn.hlag.cloud/hlagwebqa.onmicrosoft.com/B2C_1A_CHANGEPASSWORD'
    }
  },
  prelive: {
    auth: {
      clientId: '64d7a44b-1c5b-4b52-9ff9-254f7acd8fc0',
      authority: 'https://identity.hapag-lloyd.com/hlagwebprod.onmicrosoft.com/B2C_1A_SIGNUP_SIGNIN_TESTING',
      knownAuthorities: ['https://identity.hapag-lloyd.com'],
      redirectUri: 'https://wwwpre.hapag-lloyd.com/solutions/auth/'
    },
    homepageUri: 'https://www.hapag-lloyd.com/en/home.html',
    aem: {
      logoutAEMUri: 'https://www.hapag-lloyd.com/en/online-business/logout-only.html'
    },
    globalFrontendScripts: 'https://wwwpre.hapag-lloyd.com/solutions/global-frontend-scripts',
    cache: MSAL_CACHE_CONFIG,
    authorities: {
      editProfile: 'https://identity.hapag-lloyd.com/hlagwebprod.onmicrosoft.com/B2C_1A_PROFILEEDIT',
      changePassword: 'https://identity.hapag-lloyd.com/hlagwebprod.onmicrosoft.com/B2C_1A_CHANGEPASSWORD'
    }
  },
  prod: {
    auth: {
      clientId: '64d7a44b-1c5b-4b52-9ff9-254f7acd8fc0',
      authority: 'https://identity.hapag-lloyd.com/hlagwebprod.onmicrosoft.com/B2C_1A_SIGNUP_SIGNIN',
      knownAuthorities: ['https://identity.hapag-lloyd.com'],
      redirectUri: 'https://www.hapag-lloyd.com/solutions/auth/'
    },
    homepageUri: 'https://www.hapag-lloyd.com/en/home.html',
    aem: {
      logoutAEMUri: 'https://www.hapag-lloyd.com/en/online-business/logout-only.html'
    },
    globalFrontendScripts: 'https://www.hapag-lloyd.com/solutions/global-frontend-scripts',
    cache: MSAL_CACHE_CONFIG,
    authorities: {
      editProfile: 'https://identity.hapag-lloyd.com/hlagwebprod.onmicrosoft.com/B2C_1A_PROFILEEDIT',
      changePassword: 'https://identity.hapag-lloyd.com/hlagwebprod.onmicrosoft.com/B2C_1A_CHANGEPASSWORD'
    }
  },
  'prod-china': {
    auth: {
      clientId: '64d7a44b-1c5b-4b52-9ff9-254f7acd8fc0',
      authority: 'https://identity.hapag-lloyd.cn/hlagwebprod.onmicrosoft.com/B2C_1A_SIGNUP_SIGNIN',
      knownAuthorities: ['https://identity.hapag-lloyd.cn'],
      redirectUri: 'https://www.hapag-lloyd.cn/solutions/auth/'
    },
    homepageUri: 'https://www.hapag-lloyd.cn/zh/home.html',
    aem: {
      logoutAEMUri: 'https://www.hapag-lloyd.cn/zh/online-business/logout-only.html'
    },
    globalFrontendScripts: 'https://www.hapag-lloyd.cn/solutions/global-frontend-scripts',
    cache: MSAL_CACHE_CONFIG,
    authorities: {
      editProfile: 'https://identity.hapag-lloyd.cn/hlagwebprod.onmicrosoft.com/B2C_1A_PROFILEEDIT',
      changePassword: 'https://identity.hapag-lloyd.cn/hlagwebprod.onmicrosoft.com/B2C_1A_CHANGEPASSWORD'
    }
  }
};
const get = () => {
  const env = (0, envDetector_1.getEnv)(window.location.href);
  return MSAL_CONFIG[env];
};
exports.cloudflare = {
  scriptSrc: 'https://challenges.cloudflare.com/turnstile/v0/api.js?compat=recaptcha',
  sitekey: '0x4AAAAAAAWKRTZgkeGf4ewg'
};
exports.default = get;
//# sourceMappingURL=config.js.map